import { Card } from "@components/cards/card";
import { IRaffleDefaultRewardDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { RaffleStatusEnum } from "@hooks/enums/raffle";
import { Masks } from "@hooks/functions/Masks/Masks";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { api } from "@service/api";
import { FiAlertTriangle } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

interface IProps {
  raffleId: string | null;
  rewards?: IRaffleDefaultRewardDTO[];
}

const masks = new Masks();
export function RaffleDefaultCardCreateRewards({
  raffleId,
  rewards = [],
}: IProps) {
  const navigate = useNavigate();
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const hasRewards = rewards.length > 0;

  const handleCreateCampaign = async () => {
    try {
      Swal.fire({
        title: "Criar Campanha?",
        text: "Esta ação não pode ser desfeita e as premiações não poderão ser editadas mais",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, criar agora!",
        cancelButtonText: "Cancelar",
      }).then(async (result: { isConfirmed: boolean }) => {
        if (result.isConfirmed) {
          const data = {
            key: raffleId,
            status: RaffleStatusEnum.PENDING,
          };
          const response = await api.put(
            `/customer/raffle/default/status`,
            data,
          );

          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      });
    } catch (error: any) {
      pushToastify({
        message:
          error?.response?.data?.message || "Falha ao carregar as informações.",
        type: "error",
        theme: "dark",
      });
    }
  };

  return (
    <Card>
      {/* Alert Header */}
      <span className="end-0 bg-warning text-white p-2 rounded-top text-center d-block">
        <FiAlertTriangle className="me-2" />
        <span className="text-uppercase">Mensagem Importante</span>
      </span>

      {/* Header */}
      <div className="card-header text-center">
        <h5 className="fw-bold mb-0">Premiação da Campanha</h5>
      </div>

      {/* Body */}
      <div className="card-body">
        {!hasRewards ? (
          /* ===================== WITHOUT REWARDS ===================== */
          <>
            <div className="text-center mb-4">
              <div className="h5 fw-bold">
                A premiação da campanha não foi encontrada.
              </div>
              <div className="text-muted">
                Enquanto a premiação não for declarada, a campanha não poderá
                ser ativada.
              </div>
              <div className="mt-2">
                Clique no botão abaixo para cadastrar a premiação.
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <button
                className="btn btn-sm btn-primary"
                onClick={() =>
                  navigate(`/raffle/default/reward/create?key=${raffleId}`)
                }
              >
                Cadastrar Premiação
              </button>
            </div>
          </>
        ) : (
          /* ===================== WITH REWARDS ===================== */
          <>
            <div className="text-center mb-3">
              <div className="h5 fw-bold">
                Sua campanha possui {rewards.length} prêmio
                {rewards.length === 1 ? "" : "s"} cadastrado
                {rewards.length === 1 ? "" : "s"}
              </div>
              <div className="text-muted">
                Você pode adicionar, remover ou editar os prêmios agora, ou
                finalizar a criação da campanha.
              </div>
            </div>

            {/* Rewards Summary */}
            <div className="row g-2 mb-4">
              {rewards.map((reward) => (
                <div className="col-md-4 col-sm-6" key={reward.id}>
                  <div className="border rounded p-2 h-100 text-center">
                    <img
                      src={reward.thumb}
                      alt={reward.name}
                      className="img-fluid mb-2 rounded"
                      style={{ maxHeight: 80, objectFit: "contain" }}
                    />
                    <div className="fw-semibold small">{reward.name}</div>
                    <div className="fst-italic small">
                      {reward.description_short}
                    </div>
                    <div className="text-muted small">
                      Preço: {masks.brlCurrency(reward.price)}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Botões */}
            <div className="d-flex justify-content-center gap-2 flex-wrap">
              <button
                className="btn btn-sm btn-success"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCreateCampaign();
                }}
              >
                Criar Campanha
              </button>

              <button
                className="btn btn-sm btn-primary"
                onClick={() =>
                  navigate(`/raffle/default/reward/create?key=${raffleId}`)
                }
              >
                Editar Premiação
              </button>
            </div>
          </>
        )}
      </div>
    </Card>
  );
}
